import { RootState } from 'store/store';
import {
  TCheckoutSession,
  TCheckoutSessionData,
} from './checkoutSession.types';
import {
  getCheckoutSessionRemainingMs,
  isCheckoutSessionExpired,
} from './checkoutSession.utils';

export const selectCheckoutSession = (
  state: RootState
): TCheckoutSession | null => state.checkoutSession.session;

export const selectCheckoutSessionData = (
  state: RootState
): TCheckoutSessionData | null =>
  state.checkoutSession.session?.checkoutData ?? null;

export const selectCheckoutSessionRemainingMs = (state: RootState): number =>
  getCheckoutSessionRemainingMs(state.checkoutSession.session);

export const selectIsCheckoutSessionExpired = (state: RootState): boolean =>
  isCheckoutSessionExpired(state.checkoutSession.session);
